const COOKIE_NAME = "webgl-enabled";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

function readCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

    return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string): void {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

// WebGL kill switch: URL param > cookie (enabled by default)
export function isWebglEnabled(): boolean {
    const params = new URLSearchParams(window.location.search);

    let enabled: boolean;

    if (params.has("webgl")) {
        enabled = params.get("webgl") !== "false";
        writeCookie(COOKIE_NAME, String(enabled));
    } else {
        const cookieValue = readCookie(COOKIE_NAME);
        enabled = cookieValue !== null ? cookieValue === "true" : true;
    }

    document.body.classList.toggle("webgl-disabled", !enabled);

    return enabled;
}
